// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".signup__forgot-password--ledian[data-v-0c1cbaf8]{border-bottom:1px solid;text-align:center}.forgot-password-link--ledian[data-v-0c1cbaf8]{color:inherit;font-size:16px;text-decoration:underline}", ""]);
// Exports
module.exports = exports;
